import store from 'state/index'
// Example service for authentication
const Auth = { 
  login(username, password) {
  },
  validateSession() {
    return this.getHeader()
  },
  logout(){
    
  },
  getHeader() {
    const uid = store.getState().uid
    return uid ? `Bearer ${uid}` : null
  }
}

export default Auth


  



// WEBPACK FOOTER //
// ./services/auth.js